import React from "react";
import { Range } from "react-range";

const CustomRange = ({
  current,
  onChange,
  baseTrackColor = "",
  activeTrackColor = "",
  dotColor = "",
  disabled = false,
}) => {
  return (
    <Range
      label="Select your value"
      step={10}
      min={0}
      max={100}
      values={[current]}
      onChange={onChange}
      disabled={disabled}
      renderTrack={({ props, children }) => (
        <div
          {...props}
          style={{
            ...props.style,
            height: "8px",
            width: "100%",
            position: "relative",
          }}
        >
          {children}
          <div
            className="h-2 w-full rounded-r-full rounded-l-full"
            style={{ background: baseTrackColor }}
          />

          <div
            className="h-2 absolute top-0 rounded-l-full"
            style={{ background: activeTrackColor, width: `${current}%` }}
          />
        </div>
      )}
      renderThumb={(
        { props, value }, // eslint-disable-line no-unused-vars
      ) => (
        <div
          {...props}
          key={props.key}
          style={{
            ...props.style,
            height: "16px",
            width: "16px",
            backgroundColor: "#fff",
            borderRadius: "50%",
            boxShadow: "3px 4px 5px 0px rgba(114, 124, 140, 0.16)",
            transform: "none !important",
            transition: "none !important",
            scale: "1 !important",
            cursor: disabled ? "not-allowed" : "grab",
          }}
          className="flex items-center justify-center outline-1 outline-white"
        >
          <div
            className="w-3 h-3 rounded-full flex items-center justify-center"
            style={{ backgroundColor: dotColor }}
          />
        </div>
      )}
      renderMark={({ props }) => <div {...props} />}
    />
  );
};

export default CustomRange;
